export const colorPalette = {
  primary: {
    charcoal: '#1f1f1f',
    oak: '#F7F4F2',
    white: '#fff',
    whiteBlueTint: '#F1F5F5',
  },
  secondary: {
    black: '#000',
    blackTransparent: 'rgba(30,30,30,0.1)',

    white: '#fff',
    whiteTransparent: 'rgba(255,255,255,0.3)',

    cyan: '#9ffbf5',
    blue: '#0000FF',
    lightBlue: '#7AC9EA',
    darkBlue: '#104a72',
    navy: '#211e2c',

    purple: '#6d56fb',
    promoPurple: '#5937f9',
    darkPurple: '#201F2C',
    lavender: '#dcdbff',

    red: '#f5665d',
    green: '#7ecb00',

    brightGreen: '#1AD36F',
    brightRed: '#FF5000',

    darkRed: '#bc332c',
    darkGreen: '#067915',

    yellow: '#fcfe7d',
    orange: 'rgb(255,156,34)',

    cream: '#F6F3EF',
    silver: '#c0c0c0',
    lightCharcoal: '#343434',
    lighterGrey: 'rgb(235,235,235)',
    osGrey: 'rgb(218,224,227)',
    cloud: '#777777',
    darkCloud: '#333',
    lightCloud: '#fafafa',
  },
  element: {
    borderLight: 'rgba(31,31,31, 0.05)',
    borderDark: 'rgba(247,244,242, 0.05)',
  },
};
